import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { convertQuantityPartsToNumbers } from '../tools/QuantityPartsConverter';
import { getDataset } from '../../../../models/Datasets';
import { NumberForMultiplyingQty } from '_legacy/constants/CommonConstants';
import './QuantityFilter.scss';

class QuantityFilter extends Component {
    constructor(props) {
        super(props);
        this.fromInputRef = React.createRef();
        this.toInputRef = React.createRef();

        this.handleFromChange = this.handleFromChange.bind(this);
        this.handleToChange = this.handleToChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleExactFromChange = this.handleExactFromChange.bind(this);
        this.handleExactToChange = this.handleExactToChange.bind(this);

        this.updateGrid = this.updateGrid.bind(this);
        this.updateGrid = debounce(this.updateGrid, 1000);

        this.clearFilter = this.clearFilter.bind(this);

        this.state = {
            from: '',
            to: '',
            exactFrom: false,
            exactTo: false,
        };
    }

    doesFilterPass(params) {
        const value = this.valueGetter(this.props.valueGetter(params.node));
        const numbers = convertQuantityPartsToNumbers(value);

        const from = this.formatNumber(this.state.from);
        const to = this.formatNumber(this.state.to);

        const minValue = Math.min(...numbers);
        const maxValue = Math.max(...numbers);
        if (from && to) {
            return (
                this.passFromFilter(
                    minValue,
                    maxValue,
                    from,
                    this.state.exactFrom
                ) &&
                this.passToFilter(minValue, maxValue, to, this.state.exactTo)
            );
        }

        if (from) {
            return this.passFromFilter(
                minValue,
                maxValue,
                from,
                this.state.exactFrom
            );
        }

        if (to) {
            return this.passToFilter(
                minValue,
                maxValue,
                to,
                this.state.exactTo
            );
        }

        return true;
    }

    passFromFilter = (minValue, maxValue, fromFilterValue, isExact) => {
        if (isExact && fromFilterValue) {
            return fromFilterValue <= minValue;
        }

        if (fromFilterValue) {
            return fromFilterValue <= maxValue;
        }

        return true;
    };

    passToFilter = (minValue, maxValue, toFilterValue, isExact) => {
        if (isExact && toFilterValue) {
            return toFilterValue >= maxValue;
        }

        if (toFilterValue) {
            return toFilterValue >= minValue;
        }

        return true;
    };

    isFilterActive() {
        return (
            this.formatNumber(this.state.from) > 0 ||
            this.formatNumber(this.state.to) > 0
        );
    }

    getModel() {
        return this.isFilterActive()
            ? {
                  to: this.state.to,
                  from: this.state.from,
                  exactFrom: this.state.exactFrom,
                  exactTo: this.state.exactTo,
              }
            : null;
    }

    setModel(model) {
        if (model) {
            this.setState(
                {
                    to: model.to,
                    from: model.from,
                    exactFrom: model.exactFrom,
                    exactTo: model.exactTo,
                },
                () => this.props.filterChangedCallback()
            );
        } else {
            this.clearFilter();
        }
    }

    formatNumber(value) {
        const numberForFormating = getDataset(
            this.props.context.datasetId
        ).numberForQuantityFormating;
        const cleanValue = Number(value.replace(/,/g, ''));

        return cleanValue <= numberForFormating
            ? cleanValue * NumberForMultiplyingQty
            : cleanValue;
    }

    valueGetter(rowValue) {
        return this.props.fieldName && rowValue
            ? rowValue[this.props.fieldName]
            : rowValue;
    }

    afterGuiAttached() {
        const multiFilter = this.props.api.getFilterInstance('cargoQuantity');
        const setFilter = multiFilter.getChildFilterInstance(1);

        const clearButton = setFilter.eGui.querySelector(
            '.ag-filter-apply-panel-button'
        );

        clearButton.addEventListener('click', () => {
            this.clearFilter();
            setTimeout(() => {
                this.refreshValues();
            }, 2000);
        });
    }

    refreshValues() {
        const multiFilter = this.props.api.getFilterInstance('cargoQuantity');
        const setFilter = multiFilter.getChildFilterInstance(1);
        setFilter.resetFilterValues();
    }

    handleFromChange(event) {
        this.handleInputChange(event, 'from');
    }

    handleExactFromChange(event) {
        const value = event.target.checked;
        this.setState({ exactFrom: value }, () => {
            this.updateGrid();
        });
    }

    handleToChange(event) {
        this.handleInputChange(event, 'to');
    }

    handleExactToChange(event) {
        const value = event.target.checked;
        this.setState({ exactTo: value }, () => {
            this.updateGrid();
        });
    }

    handleInputChange(event, fieldName) {
        var validationRegex = /^[\d,]*\.?\d*$/;
        const value = event.target.value;

        if (validationRegex.test(value)) {
            this.setState({ [fieldName]: value }, () => {
                this.updateGrid();
            });
        }
    }

    updateGrid() {
        this.props.filterChangedCallback();
    }

    clearFilter() {
        this.setState(
            { from: '', to: '', exactTo: false, exactFrom: false },
            () => {
                this.props.filterChangedCallback();
            }
        );
    }

    numberWithCommas(number) {
        return number
            .replace(/,/g, '')
            .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }

    render() {
        return (
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                    }}
                >
                    <input
                        id="dwt-from-input"
                        type="text"
                        className="dwt-filter-input"
                        value={this.numberWithCommas(this.state.from)}
                        onChange={this.handleFromChange}
                        placeholder="From"
                        min={0}
                    />
                    <label
                        style={{
                            display: 'flex',
                            gap: 5,
                            marginLeft: 10,
                            marginBottom: 10,
                        }}
                    >
                        <input
                            id="dwt-exactFrom-input"
                            type="checkbox"
                            checked={this.state.exactFrom}
                            onChange={this.handleExactFromChange}
                        />
                        Exact Only
                    </label>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                    }}
                >
                    <input
                        id="dwt-to-input"
                        type="text"
                        className="dwt-filter-input"
                        value={this.numberWithCommas(this.state.to)}
                        onChange={this.handleToChange}
                        placeholder="To"
                    />
                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5,
                            marginLeft: 10,
                            marginBottom: 10,
                        }}
                    >
                        <input
                            id="dwt-exactTo-input"
                            type="checkbox"
                            checked={this.state.exactTo}
                            onChange={this.handleExactToChange}
                        />
                        Exact Only
                    </label>
                </div>
            </div>
        );
    }
}

export default QuantityFilter;
